import get from 'lodash/get';

import isMobileJS from 'ismobilejs';
import { isBrowserSafari } from './utils';

/**
 * List of all IMA SDK event values, along with their corresponding constants
 */
export const imaEvents = [
  'adBreakReady', // google.ima.AdEvent.Type.AD_BREAK_READY
  'adCanPlay', // google.ima.AdEvent.Type.AD_CAN_PLAY
  'adMetadata', // google.ima.AdEvent.Type.AD_METADATA
  'allAdsCompleted', // google.ima.AdEvent.Type.ALL_ADS_COMPLETED
  'click', // google.ima.AdEvent.Type.CLICK
  'complete', // google.ima.AdEvent.Type.COMPLETE
  'contentPauseRequested', // google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED
  'contentResumeRequested', // google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED
  'durationChange', // google.ima.AdEvent.Type.DURATION_CHANGE
  'expandedChanged', // google.ima.AdEvent.Type.EXPANDED_CHANGED
  'firstquartile', // google.ima.AdEvent.Type.FIRST_QUARTILE
  'impression', // google.ima.AdEvent.Type.IMPRESSION
  'interaction', // google.ima.AdEvent.Type.INTERACTION
  'linearChanged', // google.ima.AdEvent.Type.LINEAR_CHANGED
  'loaded', // google.ima.AdEvent.Type.LOADED
  'log', // google.ima.AdEvent.Type.LOG
  'midpoint', // google.ima.AdEvent.Type.MIDPOINT
  'pause', // google.ima.AdEvent.Type.PAUSED
  'resume', // google.ima.AdEvent.Type.RESUMED
  'skippableStateChanged', // google.ima.AdEvent.Type.SKIPPABLE_STATE_CHANGED
  'skip', // google.ima.AdEvent.Type.SKIPPED
  'start', // google.ima.AdEvent.Type.STARTED
  'thirdquartile', // google.ima.AdEvent.Type.THIRD_QUARTILE
  'userClose', // google.ima.AdEvent.Type.USER_CLOSE
  'viewable_impression', // google.ima.AdEvent.Type.VIEWABLE_IMPRESSION
  'volumeChange', // google.ima.AdEvent.Type.VOLUME_CHANGED
  'mute', // google.ima.AdEvent.Type.VOLUME_MUTED
  'adError', // google.ima.AdErrorEvent.Type.AD_ERROR
];

/**
 * IMA Ads Manager Loaded Callback.
 *
 * Registers event listeners that will turn IMA events into player events.
 */
export function adsManagerLoadedCallback() {
  this.settings.adsManagerLoaded = true;

  imaEvents.forEach(imaEvent => {
    this.player.ima.addEventListener(imaEvent, event => {
      this.player.trigger(`ads-ima-${event.type}`, event);
    });
  });
}

/**
 * Returns the ad start event to listen on
 */
export function getAdStartEvent(navigator) {
  if (isMobileJS.any) {
    return 'touchend';
  }

  if (isBrowserSafari(navigator)) {
    return 'click';
  }

  return 'loadeddata';
}

/**
 * Wait for AdsLoader IMA object to be ready.
 */
export function isAdsLoaderReady(player) {
  const waitForAdsLoader = (playerInst, resolvePromise) => {
    if (get(playerInst, 'ima.controller.sdkImpl.adsLoader', false)) {
      return resolvePromise(true);
    }
    setTimeout(waitForAdsLoader.bind(this, playerInst, resolvePromise), 50);
  };

  return new Promise(resolve => {
    if (get(player, 'ima.controller.sdkImpl.adsLoader', false)) {
      return resolve(true);
    }
    setTimeout(waitForAdsLoader.bind(this, player, resolve), 50);
  });
}

/**
 * Wait for AdsManager IMA object to be ready.
 */
export function isAdsManagerReady(encore) {
  const waitForAdsLoader = (encoreInst, resolvePromise) => {
    if (encore.settings.adsManagerLoaded) {
      return resolvePromise(true);
    }
    setTimeout(waitForAdsLoader.bind(this, encoreInst, resolvePromise), 50);
  };

  return new Promise(resolve => {
    if (encore.settings.adsManagerLoaded) {
      return resolve(true);
    }
    setTimeout(waitForAdsLoader.bind(this, encore, resolve), 50);
  });
}
